module.exports = __webpack_public_path__ + "static/media/plus.7f5d2a94.svg";